import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../../Navbar";
import Header from "../../../Header";
import baseUrl from "../../../BaseUrl";
import Pagination from "react-js-pagination";
import { useNavigate, Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from "../../../Loader";
import formatDateTimeToPST from '../../../PSTDateConvert';

const TnHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { initialFilters } = location.state || {};

  // Calculate dates for default filters (last 30 days)
  const today = new Date();
  const thirtyDaysAgo = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000));
  
  const formatDateForState = (date) => {
    return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
  };

  const [name, setName] = useState('');
  const [timeZone, seTimeZone] = useState('');
  const [token, setToken] = useState('');
  const [cid, setCid] = useState('');
  const [expire, setExpire] = useState('');  
  const [role, setRole] = useState('');
  const [access, setAccess] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [loadingCount, setLoadingCount] = useState(0);
  const [companies, setCompanies] = useState([])

  const [selectedCompany, setSelectedCompany] = useState(initialFilters?.selectedCompany || "");
  const [callPassDisplayIdentitiesAccess, setCallPassDisplayIdentitiesAccess] = useState(false);
  const [userCallPassDisplayIdentitiesAccess, setUserCallPassDisplayIdentitiesAccess] = useState(false);

  const [page, setPage] = useState(1);
  const [totalItem, setTotalItem] = useState(0);

  const [searchFilters, setSearchFilters] = useState({
    tnNumber: '',
    createdStartDate: formatDateForState(thirtyDaysAgo),
    createdEndDate: formatDateForState(today),
    deletedStartDate: '',
    deletedEndDate: ''
  })
  
  const [displayCreatedStart, setDisplayCreatedStart] = useState(thirtyDaysAgo);
  const [displayCreatedEnd, setDisplayCreatedEnd] = useState(today);
  const [displayDeletedStart, setDisplayDeletedStart] = useState('');
  const [displayDeletedEnd, setDisplayDeletedEnd] = useState('');

  const [tnHistory, setTnHistory] = useState([]);

  
  const axiosJWT = axios.create();
 
  axiosJWT.interceptors.request.use(async (config) => {
    const currentDate = new Date();
    if (expire * 1000 < currentDate.getTime()) {
      const response = await axios.get(`${baseUrl}/token`);
      config.headers.Authorization = `Bearer ${response.data.accessToken}`;
      setToken(response.data.accessToken);
      const decoded = jwt_decode(response.data.accessToken);
      setName(decoded.name);
      seTimeZone(decoded.timezone);
      setRole(decoded.role)
      setExpire(decoded.exp);
      setCid(decoded.cid);
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  useEffect(() => {
    refreshToken();
    getUserCompanies();
  }, []);

  useEffect(() => {
    if(cid){
      checkPageAccess();
    }
  }, [cid]);

  const incrementLoading = () => setLoadingCount((prev) => prev + 1);
  const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));
  
    useEffect(() => {
      setPopupOpen(loadingCount > 0);
    }, [loadingCount]);
  
    useEffect(() => {
      if(role >= 3 && cid){
        setSelectedCompany(cid);
      }
    }, [cid, role]);

    useEffect(() => {
      fetchTnHistory(page,selectedCompany, searchFilters.tnNumber, searchFilters.createdStartDate, searchFilters.createdEndDate, searchFilters.deletedStartDate, searchFilters.deletedEndDate)
    }, [page]);

  const refreshToken = async () => {
    try {
        const response = await axios.get(`${baseUrl}/token`);
        
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        console.log(decoded);
        setName(decoded.name);
        seTimeZone(decoded.timezone);
        setRole(decoded.role)
        setExpire(decoded.exp);
        setCid(decoded.cid);
    } catch (error) {
        if (error.response) {
            // setError("Unauthorized");
            navigate("/");  
            window.location.reload();
        }
    }
  }
  
  const checkPageAccess = async () => {
    try {
        incrementLoading();
        // Fetch all required data            
        const customerDigitMappingResponse = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        const userAccessResponse = await axiosJWT.get(`${baseUrl}/user-access`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        
        const callPassDisplayIdentitiesSwitch = customerDigitMappingResponse.data.call_pass_display_identities_switch;
        const userCallPassDisplayIdentitiesSwitch = userAccessResponse.data.user_call_pass_display_identities_switch;
        decrementLoading();
        setAccess(userAccessResponse.data.results);
        // Conditional check for access
        if (
            callPassDisplayIdentitiesSwitch >= 1 &&
            userCallPassDisplayIdentitiesSwitch >= 1
        ) {
            setUserCallPassDisplayIdentitiesAccess(true);
            setCallPassDisplayIdentitiesAccess(true);
        } else {
            navigate('/dashboard');
        }
    } catch (error) {
        console.error("Error checking page access:", error);
        navigate('/dashboard'); // Redirect in case of any error
    }
  };

  const getUserCompanies = async () => {
      
      const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
          headers: {
              Authorization: `Bearer ${token}`
          }
      });
      const company = response.data.filter(item => item.id !== 1);
      setCompanies(company);
  }

  const fetchTnHistory = async (page,comapny, tnNumber, createdStartDate, createdEndDate, deletedStartDate, deletedEndDate) => {
    try {
      incrementLoading();
      const response = await axiosJWT.get(`${baseUrl}/call-pass-display-identities/tn/history?page=${page}&limit=20&company=${comapny}&number=${tnNumber}&createdStartDate=${createdStartDate}&createdEndDate=${createdEndDate}&deletedStartDate=${deletedStartDate}&deletedEndDate=${deletedEndDate}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setTnHistory(response.data.data || []);
      setTotalItem(response.data.totalItem || 0);
    } catch (error) {
      console.error('Error fetching TN history:', error);
      setTnHistory([]);
      setTotalItem(0);
    } finally {
      decrementLoading();
    }
  };

  const handleTnNumberChange = (e) => {
    setSearchFilters((prev) => ({ ...prev, tnNumber: e.target.value }));
  };

  const formatDateString = (date) => {
    return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
  };

  const handleCreatedStartDateChange = (date) => {
    if (date) {
      const formattedDate = formatDateString(date);
      setSearchFilters((prev) => ({ ...prev, createdStartDate: formattedDate }));
      setDisplayCreatedStart(date);
    } else {
      setSearchFilters((prev) => ({ ...prev, createdStartDate: '' }));
      setDisplayCreatedStart(null);
    }
  };

  const handleCreatedEndDateChange = (date) => {
    if (date) {
      const formattedDate = formatDateString(date);
      setSearchFilters((prev) => ({ ...prev, createdEndDate: formattedDate }));
      setDisplayCreatedEnd(date);
    } else {
      setSearchFilters((prev) => ({ ...prev, createdEndDate: '' }));
      setDisplayCreatedEnd(null);
    }
  };

  const handleDeletedStartDateChange = (date) => {
    if (date) {
      const formattedDate = formatDateString(date);
      setSearchFilters((prev) => ({ ...prev, deletedStartDate: formattedDate }));
      setDisplayDeletedStart(date);
    } else {
      setSearchFilters((prev) => ({ ...prev, deletedStartDate: '' }));
      setDisplayDeletedStart(null);
    }
  };

  const handleDeletedEndDateChange = (date) => {
    if (date) {
      const formattedDate = formatDateString(date);
      setSearchFilters((prev) => ({ ...prev, deletedEndDate: formattedDate }));
      setDisplayDeletedEnd(date);
    } else {
      setSearchFilters((prev) => ({ ...prev, deletedEndDate: '' }));
      setDisplayDeletedEnd(null);
    }
  };

  const handlePageChange  = (pageNumber) => {
    setPage(pageNumber);
  }

  const handleSearchSubmit = () => {
    setPage(1);
    fetchTnHistory(1, selectedCompany, searchFilters.tnNumber, searchFilters.createdStartDate, searchFilters.createdEndDate, searchFilters.deletedStartDate, searchFilters.deletedEndDate)
  };

  const clearFilter = () => {
    setSearchFilters({
      tnNumber: '',
      createdStartDate: '',
      createdEndDate: '',
      deletedStartDate: '',
      deletedEndDate: ''
    });
    setDisplayCreatedStart(null);
    setDisplayCreatedEnd(null);
    setDisplayDeletedStart(null);
    setDisplayDeletedEnd(null);
    setPage(1);
    fetchTnHistory(1, selectedCompany, '', '', '', '', '');
  };

  const gotoDisplayIdentitiesScreen = (e) => {
    e.preventDefault();
    const navigationState = {
        initialFilters: { // Current filter values from Summary page
            selectedCompany,
        }
    }
    navigate("/call-pass-display-identities", { state: navigationState });
  }

  return (
    <div className="panelbox">
      <Navbar  token={token} access = {access}/>
        <div className="right-panel">
          <Header name={name} />
          {popupOpen && <Loader/>}
          <div className="content-page">

            <div className="row">
              <div className="col-8">
                  <div className="left-title">
                      <h1>Call Pass Display Identities - Tn History</h1>
                  </div>
              </div> 
              <div className="col-4 top-right-buttons">                                        
                  <div className="export-btn addnew-button"><a onClick={(e) => gotoDisplayIdentitiesScreen(e)}><span>&larr;</span> Back</a></div>
              </div>                     
            </div>

            <div className='common-white-shadow-background setting-section'>
              <div className="flex items-baseline flex-wrap gap-2"> 
                    {role <=2 && (
                      <div className="">
                        <label htmlFor="companySelect">Company:</label>
                        <select id="companySelect" value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)} className="form-control">
                          <option value="" >Company</option>
                          {companies.map(option => (
                            <option key={option.id} value={option.id}>{option.cname}</option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className='w-10'>
                      <label>Number:</label>
                      <input 
                        type="text" 
                        name="search" 
                        placeholder="Search tn number" 
                        value={searchFilters.tnNumber} 
                        onChange={handleTnNumberChange} 
                      /> 
                    </div>

                    <div className='flex flex-col'>
                      <label>Created From:</label>
                      <DatePicker
                        selected={displayCreatedStart}
                        onChange={handleCreatedStartDateChange}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="Created From Date"
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Created To:</label>
                      <DatePicker
                        selected={displayCreatedEnd}
                        onChange={handleCreatedEndDateChange}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="Created To Date"
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Deleted From:</label>                    
                      <DatePicker
                        selected={displayDeletedStart}
                        onChange={handleDeletedStartDateChange}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="Deleted From Date"
                      />
                    </div>

                    <div className='flex flex-col'>
                      <label>Deleted To:</label>
                      <DatePicker
                        selected={displayDeletedEnd}
                        onChange={handleDeletedEndDateChange}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="Deleted To Date"
                      />
                    </div>

                    <div className="flex self-center mt-3">  
                      <button  className="search-btn" onClick={handleSearchSubmit}>Search</button>
                      { (searchFilters.tnNumber 
                        || searchFilters.createdStartDate 
                        || searchFilters.createdEndDate 
                        || searchFilters.deletedStartDate 
                        || searchFilters.deletedEndDate
                        ) && (<a className='search-btn clear-btn w-max' onClick={clearFilter} >Clear</a>)}    
                    </div>
              </div>
            </div>

            <div className="common-white-shadow-background setting-section">
                <div className="row">
                <div className=" setting-section haft-whitebox">
                    <div className="search-result-section">
                        <h3></h3>
                        {/* <div className="export-btn newrow"><a className="newrow" href="#">Export</a></div> */}
                    </div>
                        <table className="tablebox search-result-table">
                            <thead>
                                <tr>
                                    <th>Tn Number</th>
                                    <th>Entity Name</th>
                                    <th>Display Identity</th>
                                    <th>Logo</th>
                                    <th>Call Reason</th>
                                    <th>Created By</th>
                                    <th>Created Date ({timeZone})</th>
                                    <th>Deleted By</th>
                                    <th>Deleted Date ({timeZone})</th>
                                </tr>
                            </thead>
                            <tbody>
                              {tnHistory.length === 0 ? (
                                <tr><td colSpan="9" style={{ textAlign: 'center' }}>No data found</td></tr>
                              ) : (
                                tnHistory.map((item, idx) => (
                                  <tr key={idx}>
                                    <td>{item.tn}</td>
                                    <td>{item?.entity_description}</td>
                                    <td>{item?.display_name}</td>
                                    <td>{item?.logo}</td>
                                    <td>{item?.call_reason}</td>
                                    <td>{item?.created_by}</td>
                                    <td>{item?.created_date ? formatDateTimeToPST(item.created_date, timeZone, role) : ''}</td>
                                    <td>{item?.deleted_by ? item.deleted_by : '-'}</td>
                                    <td>{item?.deleted_date ? formatDateTimeToPST(item.deleted_date, timeZone, role) : '-'}</td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                        </table>
                        
                        {totalItem > 20 && (<Pagination
                          activePage={page}
                          itemsCountPerPage={20}
                          totalItemsCount={totalItem}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange.bind(this)}
                        />)}
                    </div>
                </div>
            </div>

          </div>
        </div>
    </div>
  )
}

export default TnHistory